import { useEffect } from 'react'
import { LngLatLike, Map as MaplibreMap } from 'maplibre-gl'
import tailWindConfig from 'tailwind-workspace-preset'
import { createBaseMarkerElement, createMaplibreMarker } from '../utils'

export type BaseMarkerProps = {
  map: MaplibreMap
  coordinates: LngLatLike
  markerColor?: string
}

const primary600 = tailWindConfig.theme.colors.primary[600]

/**
 * Component that represents a single pin on the map. Pass in a markerColor to change the color and the default
 * is our primary green. color.
 */
export const BaseMarker = ({ map, coordinates, markerColor = primary600 }: BaseMarkerProps) => {
  useEffect(() => {
    if (map) {
      const domElement = createBaseMarkerElement(markerColor)
      const markerEl = createMaplibreMarker(domElement, coordinates, map)

      return () => {
        markerEl?.remove()
      }
    }

    // Just to shut TypeScript up about not all code paths returning a value.
    return
  }, [coordinates, markerColor, map])

  return null
}
